import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../../../context/ProductBuilder/machine';
import { getHoneycombRailHexColour } from '../../../../../helpers/getHexColorCode';
import { getPatternImages } from '../../../../../helpers/getPatternImages';

export const HoneycombStandard = React.forwardRef(
  (
    props: React.SVGProps<SVGSVGElement>,
    setProductImageRef: React.Ref<SVGSVGElement>,
  ) => {
    const [state] = useService(productBuilderMachine);
    const patternUrl = getPatternImages(state);

    const lightGuards =
      typeof state.context.custom.lightGuards === 'number' ? 'Yes' : '';

    const railColour = state.context.custom.railColour
      ? state.context.custom.railColour
      : 'White';

    const railColourHex = getHoneycombRailHexColour(railColour);

    if (lightGuards !== 'Yes') {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 554.2 420"
          {...props}
          preserveAspectRatio="none"
        >
          <defs>
            <pattern
              id="honeycombStandard"
              patternUnits="userSpaceOnUse"
              width="100"
              height="100"
            >
              <image href={patternUrl} x="0" y="0" width="100" height="100" />
            </pattern>
          </defs>
          <g ref={setProductImageRef}>
            <path fill="url(#honeycombStandard)" d="M5 10h544.2v251.5H5z" />
          </g>

          <linearGradient
            id="prefix__a"
            gradientUnits="userSpaceOnUse"
            x1={277.1}
            y1={235.941}
            x2={277.1}
            y2={254}
            gradientTransform="matrix(1 0 0 -1 0 264)"
          >
            <stop offset={0.489} stopOpacity={0} />
            <stop offset={1} stopOpacity={0.3} />
          </linearGradient>
          <path fill="url(#prefix__a)" d="M5 10h544.2v18.1H5z" />
          <g fill={`${railColourHex}`}>
            <path d="M0 0h554.2v10H0zM0 256.5h554.2v5H0z" />
          </g>
        </svg>
      );
    } else {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 554.2 420"
          {...props}
          preserveAspectRatio="none"
        >
          <defs>
            <pattern
              id="honeycombStandard"
              patternUnits="userSpaceOnUse"
              width="100"
              height="100"
            >
              <image href={patternUrl} x="0" y="0" width="100" height="100" />
            </pattern>
          </defs>
          <path fill="url(#honeycombStandard)" d="M5 10h544.2v251.5H5z" />
          <linearGradient
            id="prefix__a"
            gradientUnits="userSpaceOnUse"
            x1={277.107}
            y1={28.059}
            x2={277.107}
            y2={10}
          >
            <stop offset={0.489} stopOpacity={0} />
            <stop offset={1} stopOpacity={0.3} />
          </linearGradient>
          <path fill="url(#prefix__a)" d="M5 10h544.2v18.1H5z" />
          <path
            d="M0 0v409h5V261.5h544.2V409h5V0H0zm549.2 256.5H5V10h544.2v246.5z"
            fill={`${railColourHex}`}
          />
        </svg>
      );
    }
  },
);
